import * as React from "react";
import CallToAction from "../../templates/callToAction";
import FeatureItemLeftSide from "../../templates/featureItemLeft";
import FeatureItemRightSide from "../../templates/featureItemRightSide";
import FooterSection from "../../templates/footer";
import NavBar from "../../templates/navbar";
import TestimonialsSection from "../../templates/testomonials";
import HeroImage from "./../../images/features-segments/hero-img.png";
import LifecycleStagesImage from "./../../images/features-segments/lifecycle-stages.png";
import SegmentBuilderImage from "./../../images/features-segments/segment-builder.png";
import SegmentEntryExitImage from "./../../images/features-segments/segment-entry-exit.png";
import SocialAdsImage from "./../../images/features-segments/social-media-ads.png";
import FeaturesHeroSection from "./../../templates/featuresHeroSection";
import { Helmet } from "react-helmet";

// Import icon images
import AquisitionSourcesIcon from "./../../images/icons/acquisition-sources.svg";
import ChannelReachIcon from "./../../images/icons/channel-reachablity.svg";
import CustomerAttributeIcon from "./../../images/icons/customer-attribute.svg";
import DeviceProfileIcon from "./../../images/icons/device-profile.svg";
import EventsIcon from "./../../images/icons/events.svg";
import LocationIcon from "./../../images/icons/location.svg";

const info = {
  allFeatures: [
    {
      icon: CustomerAttributeIcon,
      title: "Segments Using Customer Attributes",
      description:
        "Segment customers based on attributes like average order value, total spent, total orders, city, gender, last activity time etc.",
    },
    {
      icon: AquisitionSourcesIcon,
      title: "Segments Using Acquisition Sources",
      description:
        "Treat customer differently based on from which marketing channels and ads they came from like Facebook, Twitter, Youtube, Google Ad etc.",
    },
    {
      icon: EventsIcon,
      title: "Segments Using Past Activities / Events",
      description:
        "Segment customers based on customers performing or not performing certain activities. Like customers who din't purchased this month but made purchases this year.",
    },
    {
      icon: DeviceProfileIcon,
      title: "Segments Using Device Profiles",
      description:
        "Segment customers based on devices like Mobile, Desktop, Tablet etc. Segment them based on browser they are using while visiting your site.",
    },
    {
      icon: LocationIcon,
      title: "Segments Using Location",
      description:
        "Segment customers based on geography like City, State, Country, Postal Code, Lattitude, Longitude etc.",
    },
    {
      icon: ChannelReachIcon,
      title: "Segments Using Channel Reachablity",
      description:
        "Segment customers based on whether they are reachable on email or SMS or WhatsApp or Push Notificaitons or  any other channels.",
    },
  ],
  segmentBuilderFeatures: [
    {
      title: "Build hyper targeting segments in minutes",
    },
    {
      title: "Combine multiple rules and filters",
    },
  ],
  customerLifeCycleFeatures: [
    {
      title: "Predefined segments based on recency and frequency of purchases",
    },
    {
      title:
        "Target customers with campaigns across different lifecycle stages.",
    },
  ],
  campaignsFeaturesList: [
    {
      title: "Use pre-defined segments and learn whom to target.",
    },
    {
      title: "Target at risk and lost customers with personalized campaigns.",
    },
  ],
  socialMediaFeaturesList: [
    {
      title: "Facebook Custom Audiances",
    },
    {
      title: "Google Custom Match",
    },
  ],
};
// markup
const IndexPage = () => {
  return (
    <main>
      <Helmet>
        <meta charset="utf-8" />
        <meta
          name="description"
          content="Maximize your ROI by grouping your users and defining different marketing strategies tailored to each segment."
        />
        <meta name="google" content="nositelinkssearchbox" />
        <title>Forms & Popups</title>
        <link rel="canonical" href="/" />
      </Helmet>

      <NavBar></NavBar>

      {/* Hero Section */}
      <FeaturesHeroSection
        image={HeroImage}
        title1="Improve your targeting with"
        title2="rich customer segments"
        description="Maximize your ROI by grouping your users and defining different  marketing strategies tailored to each segment."
        paddingRight="pr-0 md:pr-10"
      ></FeaturesHeroSection>

      {/* Segment Builder Section */}
      <FeatureItemLeftSide
        features={info.segmentBuilderFeatures}
        image={SegmentBuilderImage}
        badge="Segment Builder"
        title="Easy to use segment builder"
        description="Growlytics's segmentation is robust and easy to use. You can
        combine multiple rules, choose from a variety of filters and
        narrow down targeting."
      ></FeatureItemLeftSide>

      {/* Customer Lifecycle Section */}
      <FeatureItemRightSide
        features={info.customerLifeCycleFeatures}
        image={LifecycleStagesImage}
        badge="RFM - Customer Lifecycle Stages"
        title="Treat customer differently based on their life cycle stage"
        description="Get clear understanding of your customers based on their purchase behaviour. Identify which segments needs re-engagement and build retention strategies for lost customers."
        imageStyle="pr-2 md:pr-0"
      ></FeatureItemRightSide>

      {/* Segment Entry Exits */}
      <FeatureItemLeftSide
        features={info.campaignsFeaturesList}
        image={SegmentEntryExitImage}
        badge="Segment Entry Exits"
        title="Followup cusotmers when enter or exit segments"
        description="Keep track of when customers are leaving or entering the segment. Run workflows and implement retention strategies when customer leave or enter different segments."
      ></FeatureItemLeftSide>

      {/* Social Media Ads Section */}
      <FeatureItemRightSide
        features={info.socialMediaFeaturesList}
        image={SocialAdsImage}
        badge="Programmatic Ads"
        title="Target segments on social media ads"
        description="Integrate your ad accounts with growlytics and sync your segments with add account. Build target audiances on ad accounts using past activities and customer data like demographics and other attributes."
      ></FeatureItemRightSide>

      {/* <!-- All Features Section --> */}
      <div className="relative sm:mt-5 md:mt-20 bg-gray-50 pt-20 pb-20 sm:pb-50">
        <div className="text-center mb-5">
          <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-badgecolor text-badgetextcolor">
            Real-time & Dynamic Segments
          </span>
        </div>
        <p className="mt-2 text-3xl px-5   font-extrabold text-gray-900 tracking-tight sm:text-4xl text-center">
          Create segments rich customer profile and behaviour
        </p>
        <p className="mt-5 px-5 max-w-prose mx-auto text-xl text-gray-500 text-center mb-20">
          Create segments based on real-time data about your customers and their
          behaviours like products they view, add to cart, purchase etc.
        </p>
        <div className="max-w-xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8 mt-15">
          <dl className="space-y-10 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-8">
            {info.allFeatures.map((feature) => (
              <div key={feature.title} className="sm:text-center">
                <dt>
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-primary-600 text-white m-auto md:ml-0">
                    <img
                      src={feature.icon}
                      className="h-10 w-10 bg-primary"
                      aria-hidden="true"
                    />
                  </div>
                  <p className="mt-5 text-lg leading-6 font-medium text-gray-900 text-center md:text-left">
                    {feature.title}
                  </p>
                </dt>
                <dd className="mt-2 text-base text-gray-500 text-center md:text-left">
                  {feature.description}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>

      {/* Testimonials Section */}
      <TestimonialsSection></TestimonialsSection>

      {/* Call To Action */}
      <CallToAction></CallToAction>

      {/* Add Footer */}
      <FooterSection></FooterSection>
    </main>
  );
};

export default IndexPage;
